import { Outlet, useLocation, useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'

import BottomShape from 'assets/images/layout/bottomShape.svg'
import sassBubble from 'assets/images/layout/sassBubble.svg'
import { BVAphases } from 'constants/HomeConstants'

import { BrandListMainHeader, ProcessMainHeader } from './BrandListMainHeader'
import { Breadcrumb } from './components/Breadcrumb'
import styles from './MainLayout.module.scss'
import { Button } from '../components/Button'

export const MainLayout = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [searchParams] = useSearchParams()

  const isBrandListRoute = location.pathname === '/BVAFrameworks'
  const isProcessRoute = location.pathname === '/process'
  const isBrandDetailsRoute = /^\/[^/]+$/.test(location.pathname) && !isBrandListRoute && !isProcessRoute
  const activeStepIndex = BVAphases.findIndex(phase => searchParams.has(phase.title))

  function redirectToBrandListPage() {
    // Navigates to the /BVAFrameworks route
    navigate('/BVAFrameworks')
  }

  return (
    <>
      <div>
        <Breadcrumb />
        {!isBrandListRoute && !isProcessRoute && !isBrandDetailsRoute && (
          <div className="pt-4 md:pt-[33px] relative">
            <div className="relative overflow-hidden h-auto min-h-[120px] md:min-h-[140px] lg:h-[166px] bg-[radial-gradient(_99.73%_355.96%_at_0.27%_45.78%,_#fe560e_7.16%,_#a9997e_27.1%,_#6bc8cd_50.57%,_#6bcaa1_72.34%,_#6bcb83_86.86%_)]">
              <p className={styles.headerWatermark}>BRAND VISION ARCHITECTURE</p>
              <div className="flex flex-wrap items-center justify-between px-4 md:px-10 lg:px-20 pt-6 md:pt-10 lg:pt-16 pb-4 md:pb-6 lg:pb-10">
                <div className="flex items-start gap-4 flex-1">
                  <p className="headline-xxl color-neutral-10">Brand Vision Architecture</p>
                  <img src={sassBubble} alt="Sass Bubble" className="self-start" height="37" />
                </div>
                <Button
                  className="min-w-24 self-center px-[16px] py-[10px] subtitle-s !font-semibold"
                  onClick={redirectToBrandListPage}
                  text="See BVA Frameworks"
                />
              </div>
            </div>
            <Outlet />
            <img src={BottomShape} alt="Bottom Shape" className="w-full" />
          </div>
        )}
        {isBrandListRoute && (
          <div>
            <BrandListMainHeader />
            <div className="brand-list-body px-4 md:px-10 lg:px-20 py-6 md:py-10">
              <Outlet />
            </div>
            <img src={BottomShape} alt="Bottom Shape" className="w-full" />
          </div>
        )}
        {isProcessRoute && (
          <div className="pt-6 md:pt-[34px] relative">
            <ProcessMainHeader activeIndex={activeStepIndex} />
            <div className="brand-list-body flex flex-col lg:flex-row gap-16 px-4 md:px-10 lg:px-20 pt-6 md:pt-10 lg:pt-16">
              <Outlet />
            </div>
            <img src={BottomShape} alt="Bottom Shape" className="w-full mt-[-40px]" />
          </div>
        )}
        {isBrandDetailsRoute && (
          <div className="pt-6 md:pt-10 relative">
            <div className="brand-list-body px-4 md:px-10 lg:px-20 pb-6 md:pb-10">
              <Outlet />
            </div>
            <img src={BottomShape} alt="Bottom Shape" className="w-full" />
          </div>
        )}
      </div>
    </>
  )
}
